module.exports = __webpack_public_path__ + "media/images/advocacy-photo-13cccaaadddc040a15919e65f1edc950.jpg";